export default __webpack_public_path__ + "static/media/insights-splash-mobile.7a07dc5b.png";